var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgServerErrorIcon = function SvgServerErrorIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 102,
    height: 100,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#server-error-icon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFAD3D",
    stroke: "#FFAD3D",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m50.667 8.333 41.666 75H9z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1F2022",
    strokeLinecap: "round",
    strokeWidth: 5.999,
    d: "M50.667 37.5v20.833"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1F2022",
    d: "M50.667 71.667a3.333 3.333 0 1 0 0-6.667 3.333 3.333 0 0 0 0 6.667"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#server-error-icon_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFAD3D",
    d: "m74.665 8 1.5 13.498 13.498 1.5-13.498 1.5-1.5 13.498-1.5-13.498-13.498-1.5 13.498-1.5z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "server-error-icon_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M59.667 8h29.996v29.996H59.667z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "server-error-icon_svg__a",
    width: 116,
    height: 116,
    x: -7.333,
    y: -4,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6002_31"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_6002_31",
    result: "shape"
  })))));
};
export default SvgServerErrorIcon;